export default __webpack_public_path__ + "static/media/EM1820.34I-42105_-25304_0.4020a3da.jpg";